var map = {
	"./1.jpg": 5476,
	"./10.jpg": 5293,
	"./2.jpg": 4826,
	"./3.jpg": 5367,
	"./4.jpg": 4022,
	"./5.jpg": 8784,
	"./6.jpg": 5970,
	"./7.jpg": 4504,
	"./8.jpg": 7551,
	"./9.jpg": 778,
	"./new_bkp/2.jpg": 7477,
	"./new_bkp/3.jpg": 1673,
	"./new_bkp/4.jpg": 6184,
	"./new_bkp/5.jpg": 3379,
	"./new_bkp/7.jpg": 2573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8136;